import {
    apiRequest,
    komponenPenilaianDetail, 
    komponenPenilaianUpdate,
} from "../../../../../../services/adapters/master/komponenPenilaianService"

class IndexRepository {
    fetchDetail = async (query) => {
        return await apiRequest("get", komponenPenilaianDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", komponenPenilaianUpdate, {
            body: query
        }, true)
    }

}

export default IndexRepository